
    <div id="sub-top">
		<div class="img-wrap">
			<img src="/assets/images/news.png">
			<h2 data-aos="fade-right" data-aos-duration="2000">
				<strong>아이로브</strong> 의 현재와 미래에 대한<br>
				한 걸음, 한 걸음의 행보와 계획을 전해드립니다. 
			</h2>
		</div>
    </div>
<section>
    <div class="sub-path-news">
        <ul [ngSwitch]='subPage'>
            <li>소식 ></li>
            <li *ngSwitchCase="'notice'">소식</li>
            <li *ngSwitchDefault></li>
        </ul>

    </div>
    

    <article [ngSwitch]='subPage'>
        <article *ngSwitchCase="'notice'"><app-notice></app-notice></article>
        <article *ngSwitchDefault></article>
    </article>
</section>